import {Injectable} from "@angular/core";
import {FileDto} from "@server-models";
import {Observable} from "rxjs";
import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";

@Injectable({
  providedIn: 'root'
})
export class SharedFileApiService extends CoreHttpClientApiBaseService {

  /**
   * @name upload
   * @description
   * make a post to orga to upload a blob file using tenantId
   * It must end the file name as .jpeg
   * max blob size 20971520
   * @memberof SharedFileApiService
   * @param tenantId
   * @param blob
   * @param fileType
   */
  upload(tenantId: number, blob: Blob, fileType: string): Observable<FileDto> {
    let body = new FormData();
    body.append('file', blob, "file." + this._splitFileType(fileType));
    return super.post<FileDto>(`/orga/file/tenant/${ tenantId }`, undefined, body);
  }

  uploadFile(tenantId: number, file: File): Observable<FileDto> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return super.post<FileDto>(`/orga/file/tenant/${tenantId}`, undefined, formData);
  }

  /**
   * @name download
   * @description
   * download a file by fileId from orga
   * @memberof SharedFileApiService
   * @param fileId
   */
  download(fileId: number): Observable<FileDto> {
    return super.get<FileDto>(`/orga/file/${ fileId }`, undefined)
  }

  /**
   * @name getFile
   * @description
   * request the blob file from param
   * @memberof SharedFileApiService
   * @param path
   */
  getFile(path: string): Observable<Blob> {
    return super.get<Blob>(path, undefined,{params: { responseType: "blob" }});
  }


  /**
   * @name _splitFileType
   * @description
   * split the blob.type sended by param ex'image/jpeg'
   * and return the 2 position (jpeg) or first position if is not longer than 1
   * @memberof SharedFileApiService
   * @param fileType
   * @private
   */
  private _splitFileType(fileType: string): string {
    const splitString = fileType.split('/');
    if (splitString.length > 0) {
      return splitString[1]
    } else {
      return splitString[0]
    }

  }
}
